(ns teamoesterreich.user-mode.news.news-details
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.util.markdown :refer [md]]))

(defn news-widget [uuid news]
  [mui/grid
   {:item true
    :key  (str "news_" uuid)
    :lg   3
    :md   4
    :sm   6
    :xs   12
    }
   ]
  )


(defn get-it []
  (let [
        !selected-news (r/cursor store/app-state [:selected-news])
        _ (log/out "!selected-news" @!selected-news)
        !news-elm (r/cursor store/app-state [:news @!selected-news])
        ]

    [:div
     [mui/grid
      {:container  true
       :direction  "row"
       :justify    "center"
       :alignItems "stretch"
       :spacing    5
       :style      {:marginTop "15px"}
       }
      [mui/grid
       {:container false
        :item      true
        :xl        6
        :lg        8
        :xs        12
        }
       [mui/card
        {:style {:margin "20px" :textAlign "center" :maxWidth "840px"}}
        [mui/card-action-area
         [mui/card-media
          {:component "img"
           :alt       (:title @!news-elm)
           :image     (:header-image-uri @!news-elm)
           :title     (:title @!news-elm)
           :style     {:maxWidth "840px"}
           }]
         [mui/card-header
          {:title                (r/as-element
                                   [:p (.toLocaleDateString (js/Date. (* 1000 (.-seconds ^js (:date @!news-elm))))) " - "
                                    (when (not (:published @!news-elm)) "[NICHT VERÖFFENTLICHT]  ")
                                    [:br]
                                    (:title @!news-elm)])
           :style                {:marginBottom "20px" :maxHeight "150px" :overflow-y "hidden"}
           :subtitle             (:content @!news-elm)
           :actAsExpander        true
           :showExpandableButton true
           }
          ]
         [mui/card-content
          {:expandable true
           :style      {:textAlign "left"}
           }
          [:div {:dangerouslySetInnerHTML {:__html (.render md (or (:long-content @!news-elm) ""))}
                 :className               "content-preview-widget"}]]
         ]]

       ]]
     [mui/grid
      {:container false
       :item      true
       :xs        12
       }
      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "space-between"
        :alignItems "flex-start"
        :spacing    1
        }
       [mui/grid
        {:container false
         :lg        8
         :xs        12
         :style     {:padding "15px"}
         }
        [mui/button
         {:variant "contained"
          :onClick #(a/set-page-back)
          }
         "Zurück"]]]]
     ]
    ))
